var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !_vm.markerConfig.hide ? _c('div', {
    staticClass: "availability-marker",
    class: {
      'availability-marker--filtered': _vm.filtered
    },
    style: _vm.styles
  }, [_vm.pulse ? _c('div', {
    staticClass: "availability-marker__ring",
    style: {
      animationDelay: _vm.animationDelay + 'ms'
    }
  }) : _vm._e(), _vm.status && _vm.status !== 'Unassigned' ? _c('div', {
    staticClass: "availability-marker__dot"
  }, [_vm.markerIcon ? _c('fa', {
    staticClass: "availability-marker__icon",
    attrs: {
      "icon": _vm.markerIcon
    }
  }) : _vm._e()], 1) : _vm._e()]) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }